"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_1 = require("../../controls/repeater");
wp.customize.controlConstructor['epsilon-repeater'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new repeater_1.EpsilonFieldRepeater(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/repeater.ts
// module id = 19
// module chunks = 0